<template>
    <div class="coupondetail">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1">&nbsp;</div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <div class="date-filter" v-if="nowType=='DAY'">
                            <el-date-picker v-model="dateStr" type="date" ref='dateInput' value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="请选择选择日期">
                            </el-date-picker>
                            <i class="iconfont icon-jiantou" @click="$refs.dateInput.handleFocus()"></i>
                        </div>
                        <div class="time-range-filter" v-if="nowType=='TIME_RANGE'">
                            <el-date-picker
                            v-model="startTime"
                            type="datetime"
                            class="dateTime"
                            default-time="00:00:00"
                            placeholder="开始时间">
                            </el-date-picker>
                            <el-date-picker
                            v-model="endTime"
                            type="datetime"
                            class="dateTime"
                            default-time="23:59:59"
                            placeholder="结束时间">
                            </el-date-picker>
                            <span class="quick-filter">
                                <span :class="nowSelFilter=='today'?'active':''" @click.stop="filter('today')">今日</span>
                                <span :class="nowSelFilter=='lastDay'?'active':''" @click.stop="filter('lastDay')">昨日</span>
                                <span :class="nowSelFilter=='week'?'active':''" @click.stop="filter('week')">本周</span>
                                <span :class="nowSelFilter=='lastWeek'?'active':''" @click.stop="filter('lastWeek')">上周</span>
                                <span :class="nowSelFilter=='month'?'active':''" @click.stop="filter('month')">本月</span>
                                <span :class="nowSelFilter=='lastMonth'?'active':''" @click.stop="filter('lastMonth')">上月</span>
                            </span>
                            <span class="types typesSearch" >
                                <span type="button" @click="searchConfirm">查询</span>
                            </span>
                        </div>
                        
                        <!--  -->
                        <!-- <div class="type-change" @click="nowType=='DAY'?nowType='TIME_RANGE':nowType='DAY'">
                            <span>{{nowType=='DAY'?'按时间段查询':'按天查询'}}</span>
                        </div> -->
                    </div>
                </div>
                <div class="HSpace2">&nbsp;</div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:10%">序号</th>
                                <th style="width:18%">优惠券名称</th>
                                <th style="width:12%">投放数</th>
                                <th style="width:12%">点击数</th>
                                <th style="width:12%">分享数</th>
                                <th style="width:12%">分享领取数</th>
                                <th style="width:12%">分享核销数</th>
                                <th style="width:12%">总核销数</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:couponList.length>pageSize}">
                                    <tr v-for="(item,ind) in couponList" class="listTr">
                                        <td style="width:10%" v-text="item.couponName?(ind+1):''"></td>
                                        <td style="width:18%">{{item.couponName}}</td>
                                        <td style="width:12%">{{item.giveTotalCount}}</td>
                                        <td style="width:12%">{{item.clickCount}}</td>
                                        <td style="width:12%">{{item.shareCount}}</td>
                                        <td style="width:12%">{{item.shareGiveCount}}</td>
                                        <td style="width:12%">{{item.verShareCount}}</td>
                                        <td style="width:12%">{{item.verTotalCount}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            
                <!-- 分页器 -->
                <!-- <div class="pager flex flex-align-center">
                    <div class="pagerCon clearfix">
                        <div class="pagerBtnBox right">
                            <div class="pagerBtn">
                                <span class="prev flex flex-align-center flex-pack-center left"><i class="el-icon-arrow-left"></i></span>
                                <span class="curPageNumber flex flex-align-center flex-pack-center left">1</span>
                                <span class="next flex flex-align-center flex-pack-center left havePage"><i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>
                        <div class="curPage flex flex-align-center right">第 1 / 9 条</div>
                        <div class="totalPage flex flex-align-center right">共100条</div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
        props: ['curStoreId','pageSize'],
        data () {
            return {
                nowSelFilter:"today",
                couponList: [],
                nowType:"TIME_RANGE",
                startTime:'',//按时间段查询的起始时间
                endTime:'',//按时间段查询的结束时间
                pickerOptions: {
                    disabledDate(time) {
                    return time.getTime() > Date.now();
                    }
                },
                dateStr: new Date().Format("yyyy-MM-dd"),
                currentPage: 1,
                totalElements: 0, //数据总条数
                canClick:true,
            }
        },
        watch: {
            dateStr(val) {
                console.log(new Date(val).Format("yyyy-MM-dd"));
                let nowDate = new Date(val).Format("yyyy-MM-dd");
                this.dateStr = nowDate;
                this.getCouponDetail(0, nowDate);
            }
        },
        methods: {
            filter(type){
                let timeRangeArr = [];
                this.nowSelFilter = type;
                switch (type) {
                    case "today":
                        // this.yearMonth = new Date().Format("yyyy-MM");
                        this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
                        // let year = new Date().Format("yyyy");
                        // let month = new Date().Format("MM");
                        this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "lastDay":
                        this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
                        this.startTime = `${new Date(new Date(this.startTime).getTime() - 1000*60*60*24).Format("yyyy/MM/dd")} 00:00:00`;
                        this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
                        this.endTime = `${new Date(new Date(this.endTime).getTime() - 1000*60*60*24).Format("yyyy/MM/dd")} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "week":
                        timeRangeArr = this.$dateRange.getThisWeek();
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "lastWeek":
                        timeRangeArr = this.$dateRange.getLastWeek();
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "month":
                        timeRangeArr = this.$dateRange.getThisMonth();
                        console.log(timeRangeArr)
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "lastMonth":
                        timeRangeArr = this.$dateRange.getLastMonth();
                        console.log(timeRangeArr)
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    default:
                        break;
                }
            },
             // 搜索
            searchConfirm: function () {
                // 
                let timeStr = new Date(this.startTime).getTime() + "-" + new Date(this.endTime).getTime();
                let nowTime = new Date().getTime();
                if(!(this.$canClickSelect("couponDetailTimeRange",timeStr,nowTime))){
                    this.$message({
                        message: '5秒内禁止重复查询相同数据',
                        customClass: 'error'
                    });
                    return;
                }
                // 
                if(((new Date(this.endTime)).getTime() - (new Date(this.startTime)).getTime()) > 1000*60*60*24*35){
                    this.$message({
                        message: '只能查询35天内的数据',
                        customClass: 'error'
                    })
                    return;
                }
                if(this.startTime!=='' && this.endTime!==''){
                    if(new Date(this.startTime)>new Date(this.endTime)){
                        this.$message({
                            message: '结束时间不能比开始时间小',
                            customClass: 'error'
                        })
                        return;
                    }
                    if(this.canClick){
                        this.canClick = false;
                        this.getCouponDetail(0, this.dateStr,"ARB");
                    }
                }else{
                    this.$message({
                        message: '请选择查询时间段',
                        customClass: 'error'
                    })
                    return;
                }
            },
            getCouponDetail: function (page=0, date, type="DAY") {

                let params;
                if(type == "DAY"){
                    params = {
                        storeId:this.curStoreId,
                        time:date,
                        type,
                        page,
                        size: this.pageSize,
                    }
                }else{
                    let begin = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                    let end = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                    params = {
                        storeId:this.curStoreId,
                        begin,
                        end,
                        type,
                        page,
                        size: this.pageSize,
                    }
                }

                this.$http({
                    url:"/coupon-instance",
                    method:"GET",
                    params
                }).then((res)=>{
                    setTimeout(()=>{
                        this.canClick = true;
                    },500);
                    let body = res.data;
                    this.couponList = body;
                    let number = this.pageSize - this.couponList.length;
                    if ( number > 0 ) {
                        for (let i = 0; i < number; i++) {
                            this.couponList.push({});
                        }
                    }
                }).catch((err)=>{
                    setTimeout(()=>{
                        this.canClick = true;
                    },500);
                })
            },
        },
        activated: function () {
            for (let i = 0; i < this.pageSize; i++) {
                this.couponList.push({
                    id: '', // 员工id
                    name: '', // 员工姓名
                    code: '', // 编号
                    mobile: '', // 手机
                    groupName: '' // 岗位id
                })
            }
            this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
            let year = new Date().Format("yyyy");
            let month = new Date().Format("MM");
            this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
            // 获取员工列表
            this.getCouponDetail(0,this.dateStr,"ARB");
        },
        mounted: function () {
            // 改变关闭样式
            $(document).ready(()=>{
                $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
            });
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
    @import "coupondetail.scss";
</style>



// WEBPACK FOOTER //
// coupondetail.vue?1f370c36